var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"enable-footer":false}},[_c('VContainer',{attrs:{"id":"login-page","fill-height":"","fluid":""}},[_c('VRow',{attrs:{"align-center":""}},[_c('VCol',{attrs:{"md":"5","offset-md":"1","offset-lg":"2","lg":"4","cols":"12"}},[_c('ResetForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }